module.exports = __webpack_public_path__ + "static/fresh-d3cf1f935d0e78ef0e3d8f2341cdf939.svg";